import {Événements} from "./constantes.js";

export class TriDéf {

    static Ordre = Object.freeze({"CROISSANT": "C", "DÉCROISSANT": "D"});
    static Source = Object.freeze({"UTILISATEUR": "U", "SYSTÈME": "S"});

    constructor(colonne, ordre, source) {
        this.colonne = colonne;
        this.ordre = ordre || TriDéf.Ordre.CROISSANT;
        this.source = source || TriDéf.Source.SYSTÈME;
    }
}

export class Tri {

    // Le nom doit correspondre exactement au nom de la clé de l'objet item (ligne) retourné par l'API mots
    static triParDéfaut = [
        new TriDéf("graphie"),
        // new TriDéf("graphieLemme"),
        new TriDéf("classe"),
        new TriDéf("genre"),
        new TriDéf("mode"),
        new TriDéf("temps"),
        new TriDéf("nombre", TriDéf.Ordre.DÉCROISSANT),
        new TriDéf("personne")
    ];


    static comparateur = new Intl.Collator("fr", { /*numeric: true,*/ sensitivity: 'base'});

    // Mémoïsation de la valeur "MEQ_LISTE_*" par item, pour éviter de rescanner
    // le tableau "étiquettes" à chaque comparaison faite par Array.sort (O(n log n) appels).
    static cacheListeMEQ = new WeakMap();

    static valeurListeMEQ(item) {
        if (!Tri.cacheListeMEQ.has(item)) {
            const étiquettes = item["étiquettes"] || [];
            const valeur = étiquettes.find(étiquette => étiquette.startsWith("MEQ_LISTE_")) ?? "";
            Tri.cacheListeMEQ.set(item, valeur);
        }
        return Tri.cacheListeMEQ.get(item);
    }

    // Si problème de performance, voir https://github.com/Pimm/mapsort
    static orderBy = (champs) => (champA, champB) => champs.map(champ => {

        let dir = champ.ordre === TriDéf.Ordre.DÉCROISSANT ? -1 : 1;

        let comparaison;
        switch (champ.colonne) {
            case "listeMEQ":
                comparaison = Tri.comparateur.compare(Tri.valeurListeMEQ(champA), Tri.valeurListeMEQ(champB));
                break;
            case "graphieLemme":
                comparaison = Tri.comparateur.compare(champA["cote"], champB["cote"]);
                break;
            default:
                comparaison = Tri.comparateur.compare(champA[champ.colonne], champB[champ.colonne]);
        }

        return comparaison > 0 ? dir : (comparaison < 0 ? -(dir) : 0);

    }).reduce((précédent, suivant) => précédent ? précédent : suivant, 0);


    constructor() {

        this.triCourant = [];
        this.triUtilisateur = [];

        const nomColonneÉléments = document.getElementById("résultats-tableau-entêtes")
            .getElementsByClassName("nomColonne");
        [...nomColonneÉléments]
            .filter(nomColonneÉlément => !["Liens"].includes(nomColonneÉlément.innerText))
            .forEach(nomColonneÉlément => nomColonneÉlément.addEventListener("click", (e) =>
                this.trieSur(e, nomColonneÉlément.parentElement.getElementsByTagName("tri-colonne-info").item(0).getAttribute("colonneId"))))

    }

    /**
     * Ajuste le tri courant et envoie l'événement Événements.TRI
     */
    trieSur(e, nomColonne, triDéf) {

        const indexColonneTriCourant = this.getIndexColonneTriUtilisateur(nomColonne);
        const triDéfCliqué = indexColonneTriCourant >= 0 ? this.triUtilisateur[indexColonneTriCourant] : undefined;

        // Si triDéf, on l'applique
        if (triDéf) {
            if (triDéfCliqué) {
                this.triUtilisateur[indexColonneTriCourant] = triDéf;
            } else {
                this.triUtilisateur.push(triDéf);
            }
        } else {
            // Si "fermé" : ouvrir, ajouter tri croissant sur colonne
            // Si ouvert : fermer, supprimer tri
            if (triDéfCliqué) {
               // Retirer du tri actif
                this.triUtilisateur.splice(indexColonneTriCourant, 1);
            } else {
                // Ajouter tri
                this.triUtilisateur.push(new TriDéf(nomColonne, TriDéf.Ordre.CROISSANT, TriDéf.Source.UTILISATEUR));
            }
        }


        const triSystèmeFiltré = Tri.triParDéfaut.filter(triDéf =>
            !this.triUtilisateur.find(triDéfUtilisateur => triDéfUtilisateur.colonne === triDéf.colonne)
        )

        this.triCourant = [...this.triUtilisateur, ...triSystèmeFiltré];

        let triChangeÉvénement = new CustomEvent(Événements.TRI,
            {
                detail: {
                    tri: this.triCourant
                }
            });

        document.dispatchEvent(triChangeÉvénement);


    }

    isTriéSur(nomColonne) {
        return this.getIndexColonneTriUtilisateur(nomColonne) !== -1
    }

    getIndexColonneTriUtilisateur(nomColonne) {
        return this.triUtilisateur.findIndex(this.isColonneTriCourant(nomColonne))
    }

    isColonneTriCourant(nomColonne) {
        return triDéf => triDéf.colonne === nomColonne;
    }


}


